import { type InstallationInfo, InstallationType } from 'generated-sources';

export function getInstallationEditUrl(installation: InstallationInfo): string {
  if (installation.type === InstallationType.ORGANIZATION) {
    return `https://github.com/organizations/${installation.login}/settings/installations/${installation.id}`;
  }
  return `https://github.com/settings/installations/${installation.id}`;
}
